import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { SALES_ANALYTICS_API_URL } from '../sales-analytics-api.constants';
import { ITipsByDayApiService } from './tips-by-day-api.interface';
import { ExportExcelPdfService } from '../../../export-excel-pdf/export-excel-pdf.service';
import { HandleBlobHttpResponseOptions } from '@orderna/admin-panel/src/types/handle-blob-http-response-options';
import { SuccessResponse } from '../../../shared/success-response';
import { ExportTipsByDayQueryDto } from './dtos/export-tips-by-day.query.dto';
import { FindTipsByDayQueryDto } from './dtos/find-tips-by-day.query.dto';
import { FindTipsByDayResponseDto } from './dtos/find-tips-by-day.response.dto';

@Injectable({
  providedIn: 'root',
})
export class TipsByDayApiService implements ITipsByDayApiService {
  private readonly ENDPOINT = 'tips-by-day';

  private http = inject(HttpClient);
  private exportService = inject(ExportExcelPdfService);

  async findTipsByDay(
    query: FindTipsByDayQueryDto
  ): Promise<FindTipsByDayResponseDto> {
    const params = new HttpParams({ fromObject: query as any });

    const response = await firstValueFrom(
      this.http.get<SuccessResponse<FindTipsByDayResponseDto>>(
        `${SALES_ANALYTICS_API_URL}/${this.ENDPOINT}`,
        { params }
      )
    );

    return response.data;
  }

  exportTipsByDay(
    query: ExportTipsByDayQueryDto,
    options?: HandleBlobHttpResponseOptions
  ) {
    const { print = false } = options ?? {};
    const params = new HttpParams({ fromObject: query as any });

    this.exportService.export({
      endpoint: this.ENDPOINT,
      params,
      print,
    });
  }
}
